<script>

  export default {
    components: {},
    props: {
      planotrabalhoequipe: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
    },
    computed: {
    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th></th>
            <th style="width:40%">Pessoa</th>
            <th style="width:40%">V&iacute;nculo</th>
            <th style="width:10%">Data in&iacute;cio</th>
            <th style="width:10%">Data fim</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(equipe, index) in planotrabalhoequipe.registros">
            <td></td>
            <td>{{ equipe.nome || '---' }}</td>
            <td>{{ equipe.nomeVinculo || '---' }}</td>
            <td>{{ equipe.dataInicio | formatarNumeroEmData }}</td>
            <td>{{ equipe.dataFim | formatarNumeroEmData }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/compartilhado/FormPlanoTrabalhoEquipe.vue